<template>
    <centered-card headline="Your Account was deleted">
        <h3>Thanks for using pimblr!</h3>
        <p>We hope, you enjoyed your stay and we will be very happy if you will return anytime.</p>
    </centered-card>
</template>

<script>
  import CenteredCard from "../layout/CenteredCard";
  export default {
    name: "AccountDeletedPage",
    components: {CenteredCard}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/AccountDeletedPage.vue